import { render } from "./Grupo.vue?vue&type=template&id=1a0cebe8&scoped=true"
import script from "./Grupo.vue?vue&type=script&lang=js"
export * from "./Grupo.vue?vue&type=script&lang=js"

import "./Grupo.vue?vue&type=style&index=0&id=1a0cebe8&scoped=true&lang=css"

import exportComponent from "/var/www/html/facturacion/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a0cebe8"]])

export default __exports__